import ImagesAuthenticationOnboardingEditSvg from '@/public/images/authentication/onboarding/edit.svg';
import ImagesAuthenticationOnboardingOnboardingBuyerInformationWebp from '@/public/images/authentication/onboarding/onboarding-buyer-information.webp';
import ImagesAuthenticationOnboardingOnboardingModalBalvenieWebp from '@/public/images/authentication/onboarding/onboarding-modal-balvenie.webp';
import ImagesAuthenticationOnboardingXSvg from '@/public/images/authentication/onboarding/x.svg';

export {
  ImagesAuthenticationOnboardingEditSvg,
  ImagesAuthenticationOnboardingOnboardingBuyerInformationWebp,
  ImagesAuthenticationOnboardingOnboardingModalBalvenieWebp,
  ImagesAuthenticationOnboardingXSvg,
};
